/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user">;
    readonly " $refType": "PdpSharedDetailShipping_user";
};
export type PdpSharedDetailShipping_user$data = PdpSharedDetailShipping_user;
export type PdpSharedDetailShipping_user$key = {
    readonly " $data"?: PdpSharedDetailShipping_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
(node as any).hash = 'bab6f1fe84d3ad648fb7f6c68a2a933f';
export default node;
